<template>
  <div>
    <my_slider
        titleWidth="54"
        :title="title"
        :value.sync="result"
        :min="0"
        :max="500"
        :precision="0"
    ></my_slider>
  </div>
</template>

<script>
import my_slider from '../my_slider'
export default {
  name: 'MyRotateIndex',
  data() {
    return {
      result: this.value
    }
  },
  components: {
    my_slider
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: '圆角'
    }
  },
  watch: {
    value(val) {
      this.result = val
    },
    result() {
      this.$emit('update:value', this.result)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
